import { Modal } from "antd";
import { useState } from "react";
import ViewAsset from "./ViewAsset";
import UpdateAsset from "./UpdateAsset";
import UpdateModel from "./UpdateModel";
import PropTypes from 'prop-types'
/**
 * Component used to manage model details
 * @param {*} props
 * @returns
 */
const ModelDetail = (props) => {
  ModelDetail.propTypes = {
    showDetail : PropTypes.any,
    title : PropTypes.any,
    model : PropTypes.any,
    showProgress : PropTypes.any,
    gltfUrl : PropTypes.any,
    assetId : PropTypes.any,
    curVer : PropTypes.any,
    selectedItem : PropTypes.any,
    fetch3DCEModels : PropTypes.any,
    page : PropTypes.any,
    verLength : PropTypes.any,
    selectedPlant : PropTypes.any,
    plantName : PropTypes.any,
    multipleVersion : PropTypes.any,
    deleteProgress : PropTypes.any,
    deleteDone : PropTypes.any,
    sas: PropTypes.any,
    closeModel :PropTypes.any
  }
  const {
    showDetail,
    title,
    model,
    showProgress,
    gltfUrl,
    assetId,
    curVer,
    selectedItem,
    fetch3DCEModels,
    page,
    verLength,
    selectedPlant,
    plantName,
    multipleVersion,
    deleteProgress,
    deleteDone,
  } = props;
  const [showUpdate, setShowUpdate] = useState(false);
  const [versionChange, setVersionChange] = useState(false);

  /**
   * Function to handle cancel action
   */
  const handleCancel = () => {
    setShowUpdate(false);
    setVersionChange(false);
    props.closeModel();
  };
  /**
   * Function to handle upload new model
   */
  const uploadNew = () => {
    setShowUpdate(true);
  };
  /**
   * Function toset the version change
   */
  const handleVersion = () => {
    setVersionChange(true);
  };

  // Determine the component to render based on conditions
let content;

if (!showUpdate) {
  content = (
    <ViewAsset
      showDetail={showDetail}
      title={title}
      model={model}
      showProgress={showProgress}
      gltfUrl={gltfUrl}
      assetId={assetId}
      curVer={curVer}
      versionChange={versionChange}
      uploadNew={uploadNew}
      handleVersion={handleVersion}
      page={page}
      verLength={verLength}
      fetchModels={fetch3DCEModels}
      handleCancel={handleCancel}
      multipleVersion={multipleVersion}
      deleteProgress={deleteProgress}
      deleteDone={deleteDone}
    />
  );
} else if (page === "3dce") {
  content = (
    <UpdateAsset
      model={model}
      assetId={assetId}
      title={title}
      handleCancel={handleCancel}
      fetch3DCEModels={fetch3DCEModels}
    />
  );
} else {
  content = (
    <UpdateModel
      title={title}
      assetId={assetId}
      selectedItem={selectedItem}
      sas={props.sas}
      fetchModels={fetch3DCEModels}
      handleCancel={handleCancel}
      selectedPlant={selectedPlant}
      plantName={plantName}
    />
  );
}

// Render the Modal with the determined content
return (
  <Modal
    open={props.showDetail}
    title={props.title}
    footer={null}
    width={1000}
    onCancel={handleCancel}
    bodyStyle={{ backgroundColor: "#262E40" }}
    style={{
      top: 70,
    }}
    maskClosable={!showUpdate}
    closable={!showUpdate}
  >
    {content}
  </Modal>
);
};
export default ModelDetail;
